import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml'
})
export class SafeHtml implements PipeTransform {
  private readonly _sanitizer = inject(DomSanitizer);

  transform(value: string): SafeHtml {
    return this._sanitizer.bypassSecurityTrustHtml(value) as SafeHtml;
  }
}
